import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
    name: 'propertyValues'
})

export class PropertyValuesPipe implements PipeTransform {
    transform(data: Object, index: number) {
        return ((<any>Object).values(data)) ? (<any>Object).values(data)[index] : null
    }
}
